// extracted by mini-css-extract-plugin
export var container = "DesktopProductModal_container__95fE5";